<template>
  <div v-if="notification" class="flash-notifications-container">
    <div class="flash-notification"
         :class="`flash-notification--${notification.type} ${notification.hiding ? 'flash-notification--hiding' : ''}`">
      <div class="flex__row flex--middle">
        <icon v-if="notification.type === 'success'" class="flash-notification__icon" icon="check" colour="white" size="medium-large"/>
        <icon v-else-if="notification.type === 'error'" class="flash-notification__icon" icon="alert" colour="white" size="medium-large"/>
        <icon v-else class="flash-notification__icon" icon="info" colour="white" size="medium-large"/>

        <div class="padding padding--horizontal padding--medium-large flash-notification__text">
          {{ notification.content }}
        </div>

        <close-button class="flash-notification__close-button"
                      size="small"
                      colour="black"
                      @click="dismissNotification()"/>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { mapActions, mapState } from 'vuex'
import { path } from 'ramda'
import CloseButton from '../Buttons/CloseButton'
import Icon from '../Icon'

export default {
  name: 'FlashNotifications',
  components: { Icon, CloseButton },
  data() {
    return {
      hiding: {},
    }
  },
  computed: {
    ...mapState(
      {
        notification: path(['notifications', 'flash', 'notification']),
      },
    ),
  },
  methods: {
    ...mapActions(
      {
        dismissNotification: 'notifications/flash/dismiss',
      },
    ),
  },
}
</script>
